<template>
  <div>
    <md-content>
      <viewer
        :content="false"
        :embed="true"
        :mode="mode"
        :nid="nuuid"
        :sid="suuid"
        :draft_sid="draft_suuid"
        field="field_go_form"
        :go-view-mode="goViewMode"
        @change-status="status = $event"
      />
    </md-content>
  </div>
</template>

<script>
import Viewer from "./Viewer.vue";

export default {
  name: "Go",
  props: ["mode", "nid", "sid", "go-view-mode", "status"],

  created() {
    let self = this;
    let fieldName = "field_go_form";
    Object.keys(
      window.drupalSettings.form_builder[this.nuuid].submissions
    ).forEach((submission) => {
      if (
        window.drupalSettings.form_builder[this.nuuid].submissions[submission]
          .template ==
          window.drupalSettings.form_builder[this.nuuid].tabs.field_go_form
            .template.uuid &&
        window.drupalSettings.form_builder[self.nuuid].submissions[
            submission
          ].section == fieldName &&
        !window.drupalSettings.form_builder[this.nuuid].submissions[submission]
          .isDraft
      ) {
        this.suuid = submission;
      }
      if (
        window.drupalSettings.form_builder[this.nuuid].submissions[submission]
          .template ==
          window.drupalSettings.form_builder[this.nuuid].tabs.field_go_form
            .template.uuid &&
        window.drupalSettings.form_builder[self.nuuid].submissions[
            submission
          ].section == fieldName &&
        window.drupalSettings.form_builder[this.nuuid].submissions[submission]
          .isDraft == true
      ) {
        this.draft_suuid = submission;
      }
    });
  },

  activated() {
    if (
      !this.goViewMode &&
      this.suuid != "" &&
      window.drupalSettings.form_builder[this.nuuid].submissions[this.suuid] &&
      !window.drupalSettings.form_builder[this.nuuid].submissions[this.suuid]
        .isDraft
    ) {
      if (
        (this.status && this.status == this.$status.ACTIVITY_COMPLETED) ||
        window.drupalSettings.form_builder[this.nuuid].submissions[this.suuid]
          .status == this.$status.ACTIVITY_COMPLETED
      ) {
        //this.$router.push("/strategy/" + this.id + "/go/thanks/completed");
      } else {
        //this.$router.push("/strategy/" + this.id + "/go/thanks");
      }
    }
    this.$emit("go-active");
    setTimeout(() => {
      window.H5P.init();
    }, 0);
  },
  data() {
    return {
      showNavigation: false,
      view_mode: this.mode || false,
      dev_mode: window.webpackHotUpdate,
      nuuid: this.nid || "",
      suuid: this.sid || "",
      id: this.$route.params.id
    };
  },
  components: {
    Viewer,
  },
  watch: {
    status(newStatus) {
      this.$emit("change-status", newStatus);
    }
  },
};
</script>
